import formInputsTypes from 'constants/simulatorData/simulatorConstant';
import ManoeuvreElectrique from 'assets/img/manoeuvre-electrique.png';
import ManoeuvreManuel from 'assets/img/manoeuvre-manuel.png';

const couleur = {
	id: 'VR-TR-TB-CC',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'couleur',
	classGroup: 'Simulateur_color',
	label: 'Couleur',
	defaultValue: 0,
	nextStep: false,
	options: [
		{
			id: 6,
			label: 'Blanc RAL 9016',
			color: '#ffffff',
			icon: 'CustomCircle',
			value: 6,
			description: '- Finition blanc RAL 9016, aspect clair et standard.',
		},
		{
			id: 14,
			label: 'Anthracite RAL 7016',
			color: '#383e42',
			icon: 'CustomCircle',
			value: 14,
			description: '- Finition gris anthracite RAL 7016, aspect moderne.',
		},
	],
};
const largeur = {
	id: 'VR-TR-VRC-W',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'largeur',
	className: 'col-6',
	label: 'Largeur (mm)',
	placeholder: '0',
	defaultValue: 0,
	nextStep: couleur,
	validation: (value) => {
		return value > 0;
	},
};
const hauteur = {
	id: 'VR-TR-VRC-H',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'hauteur',
	className: 'col-6',
	label: 'Hauteur (mm)',
	defaultValue: 0,
	placeholder: '0',
	nextStep: largeur,
	validation: (value) => {
		return value > 0;
	},
};

const typeManoeuvre = {
	id: 'VR-TR-VRC-TM',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'typeManoeuvre',
	className: 'col-6',
	label: 'Manœuvre',
	nextStepData: false,
	options: [
		{
			id: 'VR-TR-VRC-TM-MNU',
			label: 'Manuel',
			value: 'Manuel',
			nextStep: hauteur,
			imageUrl: ManoeuvreManuel,
			description: '- Manœuvre manuelle de la porte de garage (sans motorisation).',
		},
		{
			id: 'VR-TR-VRC-TM-ELE',
			label: 'Électrique',
			value: 'Électrique',
			nextStep: hauteur,
			imageUrl: ManoeuvreElectrique,
			description:
				'- Manœuvre motorisée de la porte de garage (prévue pour motorisation électrique).',
		},
	],
};
const PorteGarageData = {
	id: 'VR-TI',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Type',
	name: 'Type',
	className: 'col-12',
	classGroup: 'Type',
	options: [
		{
			id: 'Basculante',
			label: 'Basculante',
			nextStep: typeManoeuvre,
			value: 'Basculante',
			description:
				'- Fourniture d’une porte de garage basculante (ouverture en bascule vers le plafond).',
		},
		{
			id: 'Sectionnelle',
			label: 'Sectionnelle',
			nextStep: typeManoeuvre,
			value: 'Sectionnelle',
			description:
				'- Fourniture d’une porte de garage sectionnelle (panneaux articulés, refoulement plafond).',
		},
	],
};

export default PorteGarageData;
